import React from 'react';
import MobileLayout from './MobileLayout';
import MobileProductManagement from './MobileProduct/MobileProductManagement';
import MobileProductionResult from './MobileProduction/MobileProductionResult';
import MobileMonitoring from './MobileMonitoring/MobileMonitoring';
import { Box, Typography, Card, CardContent, Button, useTheme, Grid } from '@mui/material';
import { useTabs } from '../../contexts/TabContext';
import { useDomain, DOMAINS } from '../../contexts/DomainContext';
import {
    ListAlt as ListAltIcon,
    SignalCellularAlt as SignalCellularAltIcon,
} from '@mui/icons-material';
import Swal from 'sweetalert2';

const MobileAppContainer = () => {
  const { activeTab, openTab } = useTabs();
  const theme = useTheme();
  const { domain } = useDomain();
  const isDarkMode = theme.palette.mode === 'dark';

  // 도메인별 색상 설정
  const getAccentColor = () => {
    if (domain === DOMAINS.PEMS) {
      return isDarkMode ? '#e67e22' : '#d35400';
    }
    return isDarkMode ? '#1976d2' : '#0a2351';
  };

  // 생산실적 메뉴 클릭 시 알림 표시
  const handleProductionResultClick = () => {
    Swal.fire({
      title: '알림',
      text: '개발 중인 메뉴입니다.',
      icon: 'info',
      confirmButtonColor: getAccentColor(),
      confirmButtonText: '확인'
    });
  };

  // 메인 화면 렌더링
  const renderMain = () => (
      <Box sx={{ width: '100%' }}>
        <Typography variant="h5" component="h1" sx={{ mb: 2, fontWeight: 'bold' }}>
          메인 화면
        </Typography>

        <Card className="mobile-card" variant="outlined" sx={{ mb: 3 }}>
          <CardContent sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Button
                    variant="contained"
                    fullWidth
                    startIcon={<ListAltIcon sx={{ fontSize: '1.8rem' }} />}
                    sx={{
                      bgcolor: getAccentColor(),
                      py: 2,
                      height: '120px',
                      fontSize: '2.8rem',
                      '& .MuiButton-startIcon': {
                        margin: 1,
                        mb: 1.5,
                        '& svg': {
                          fontSize: '3rem'
                        }
                      }
                    }}
                    onClick={() => openTab({ id: 'pd-production-result', name: '생산실적등록', group: 'pd' })}
                >
                <Typography variant="contained" sx={{ mb: 1.5, fontSize: '2.5rem' , textAlign: 'center' }}>
                    실적등록
                </Typography>
                </Button>
              </Grid>
              <Grid item xs={12}>
                    <Button
                        variant="contained"
                        fullWidth
                        startIcon={<SignalCellularAltIcon sx={{ fontSize: '1.8rem' }} />}
                        sx={{
                            bgcolor: getAccentColor(),
                            py: 2,
                            height: '120px',
                            fontSize: '2.8rem',
                            '& .MuiButton-startIcon': {
                                margin: 1,
                                mb: 1.5,
                                '& svg': {
                                    fontSize: '3rem'
                                }
                            }
                        }}
                        onClick={() => openTab({ id: 'mo-monitoring', name: '모니터링', group: 'mo' })}
                    >
                    <Typography variant="contained" sx={{ mb: 1.5, fontSize: '2.5rem' , textAlign: 'center' }}>
                       모니터링
                    </Typography>
                    </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>

        <Card className="mobile-card" variant="outlined">
          <CardContent sx={{ p: 2 }}>
            <Typography variant="subtitle1" sx={{ mb: 1.5, fontWeight: 'bold', fontSize: '1.2rem' , textAlign: 'center' }}>
                ※ 공지사항 ※
            </Typography>
            <Typography variant="body1" sx={{ fontSize: '1.1rem', lineHeight: 1.5 , textAlign: 'center' }}>

                더 많은 기능을 이용하시려면 <br></br>
              <strong> PC 버전</strong>을 사용하시기 바랍니다.
            </Typography>
          </CardContent>
        </Card>
      </Box>
  );

  // 활성화된 탭에 따라 컨텐츠 렌더링
  const renderContent = () => {
    if (!activeTab || activeTab === 'main') {
      return renderMain();
    }

    switch (activeTab) {
      case 'pi-product':
        return <MobileProductManagement />;
      case 'pd-production-result':
        return <MobileProductionResult />;
      case 'mo-monitoring':
        return <MobileMonitoring />;
      default:
        return renderMain();
    }
  };

  return (
      <MobileLayout>
        {renderContent()}
      </MobileLayout>
  );
};

export default MobileAppContainer;